"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ResponsiveAdManager_1 = require("../../components/ResponsiveAdManager");
var jquery_1 = __importDefault(require("jquery"));
googletag.cmd.push(function () {
    if (!siteData) {
        return;
    }
    googletag.pubads().setTargeting("mediaPlatform", "browser");
    googletag.pubads().setTargeting("dartSection", siteData.section);
    googletag.pubads().setTargeting("dartSubSection", siteData.subSection);
    googletag.pubads().setTargeting("subscription", siteData.subscriptions);
    googletag.pubads().setTargeting("Tag", siteData.tags);
    googletag.pubads().setTargeting("Interest", siteData.interests);
    googletag.pubads().setTargeting("ageGroup", siteData.ageGroup);
    googletag.pubads().setTargeting("companyBranch", siteData.companyBranch);
    googletag.pubads().setTargeting("companyFunction", siteData.companyFunction);
    googletag.pubads().setTargeting("title", siteData.title);
    googletag.pubads().setTargeting("isin", siteData.isin);
    googletag.pubads().setTargeting("articleSource", siteData.articleSource);
    googletag.pubads().setTargeting("articleId", siteData.articleId);
});
(0, jquery_1.default)(function () {
    var responsiveAdManager = new ResponsiveAdManager_1.ResponsiveAdManager();
    if (siteData && siteData.adslotsDisabled == true)
        console.log('Slots are disabled');
    else
        responsiveAdManager.process();
});
